export default __webpack_public_path__ + "static/media/Mayank.0cf9f136.jpeg";